import * as React from 'react';
import { NavLink } from 'react-router-dom';
import * as styles from './header.module.scss';

interface Props {
  title: string;
  path: string;
  isExternal: boolean;
}

/**
 * HeaderLink
 * @function HeaderLink Component for each link in the header
 */
const HeaderLink = ({ title, path, isExternal }: Props) => {
  return !isExternal ? (
    <div className={styles.linkWrapper}>
      <NavLink activeClassName={styles.headerLinkActive} className={styles.headerLink} to={path}>
        <span>{title}</span>
      </NavLink>
    </div>
  ) : (
    <div className={styles.linkWrapper}>
      <a href={path} className={styles.headerLink} target="_blank">
        <span>{title}</span>
      </a>
    </div>
  );
};

export default HeaderLink;
